import * as React from 'react';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import DownIcon from '@mui/icons-material/ExpandMore';
import UpIcon from '@mui/icons-material/ExpandLess';

import Flights from 'components/BookingsList/Flights';
import Hotels from 'components/BookingsList/Hotels';
import Cars from 'components/BookingsList/Cars';

import { connectWithRouter } from 'helpers/connectWithRouter';
import { get, emptyResults } from 'actions/Bookings/Get';
import { bindActionCreators } from 'redux';

const styles = require('./styles.pcss');

class BookingsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTabIndex: 0,
      open: false,
      sortBy: 'upcoming',
    };

    this.onTabChange = this.onTabChange.bind(this);
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleArrow = () => {
    if (this.state.open) {
      return <UpIcon className={styles.icon} />;
    }
    return <DownIcon className={styles.icon} />;
  };

  handleChangeSortBy = (value) => {
    this.props.emptyResults();
    this.setState({
      sortBy: value,
    });
  };

  componentWillUnmount() {
    this.props.emptyResults();
  }

  onTabChange(e, idx) {
    this.props.emptyResults();
    this.setState({
      activeTabIndex: idx,
    });
  }

  renderTable() {
    switch (this.state.activeTabIndex) {
      case 0: {
        return (
          <Flights
            noBorder={true}
            flights={this.props.bookings}
            get={this.props.get}
            emptyResults={this.props.emptyResults}
            isLoading={this.props.isLoading}
            loadedAllFlight={this.props.loadedAll}
            travelerId={this.props.travelerId}
            userId={this.props.userId}
            sort={this.state.sortBy}
            order={'departureDate ASC'}
          />
        );
      }

      case 1: {
        return (
          <Hotels
            noBorder={true}
            hotels={this.props.bookings}
            get={this.props.get}
            emptyResults={this.props.emptyResults}
            isLoading={this.props.isLoading}
            loadedAllHotel={this.props.loadedAll}
            travelerId={this.props.travelerId}
            userId={this.props.userId}
            sort={this.state.sortBy}
            order={'arrivalDate ASC'}
          />
        );
      }

      case 2: {
        const hasProviderPickupDate = Array.isArray(this.props.bookings) &&
        this.props.bookings.every(b => b.providerPickupDate);

        const orderField = hasProviderPickupDate ? 'providerPickupDate' : 'pickupDateTime';
        return (
          <Cars
            noBorder={true}
            cars={this.props.bookings}
            get={this.props.get}
            emptyResults={this.props.emptyResults}
            isLoading={this.props.isLoading}
            loadedAllCars={this.props.loadedAll}
            travelerId={this.props.travelerId}
            userId={this.props.userId}
            sort={this.state.sortBy}
            order={`${orderField} ASC`}
          />
        );
      }
    }
  }

  render() {
    return (
      <div className="pageWrapper">
        <Tabs
          className={styles.tabbs}
          value={this.state.activeTabIndex}
          indicatorColor="primary"
          textColor="primary"
          onChange={this.onTabChange}
        >
          <Tab
            className={styles.tabb}
            label="Flights"
          />
          <Tab
            className={styles.tabb}
            label="Hotels"
          />
          <Tab
            className={styles.tabb}
            label="Cars"
          />

          <div className={styles.sortBy}>
            Show:
            <Select
              open={this.state.open}
              onClose={this.handleClose}
              onOpen={this.handleOpen}
              autoWidth={false}
              className={styles.select}
              value={this.state.sortBy}
              onChange={(e) => {
                this.handleChangeSortBy(e.target.value);
              }}
              IconComponent={this.handleArrow}
              inputProps={{ className: styles.input }}
              MenuProps={{
                style: { left: '-65px' },
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
              }}
            >
              <MenuItem
                value={'upcoming'}
                style={{ minWidth: '190px' }}
              >
                Upcoming
              </MenuItem>
              <MenuItem value={'past'}>Past</MenuItem>
              <MenuItem value={'canceled'}>Canceled</MenuItem>
            </Select>
          </div>
        </Tabs>

        {this.renderTable()}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      get,
      emptyResults,
    },
    dispatch,
  );
}

function mapStateToProps(state) {
  return {
    sort: state.bookings.sort,
    isLoading: state.bookings.isLoading,
    bookings: state.bookings.bookings,
    loadedAll: state.bookings.loadedAll,
  };
}

export default connectWithRouter(mapStateToProps, mapDispatchToProps)(BookingsTable);
